/**
 * @deprecated
 * Includes are deprecated. See IMP-1330
 */
export enum INTERVENTION_INCLUDES {
  FOLLOWUP = "followup",
  PROJECT = "project",
}
